import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {IsGranted} from '../../../../../decorator/is-granted';
import {MetaTitle} from '../../../../../decorator/meta-title';
import {TranslationMessageService} from '../../../../../services/translation-message/translation-message.service';
import {LoaderService} from '../../../../../services/loader/loader.service';
import {TranslationMessage} from '../../../../../models/translation/translation-message';
import {FormsModule} from '@angular/forms';
import {NgOptimizedImage} from '@angular/common';
import {TableSorterHeaderDirective} from '../../../../../directives/table-sorter/table-sorter-header.directive';
import {TableSorterDirective} from '../../../../../directives/table-sorter/table-sorter.directive';
import {TableSorter} from '../../../../../tools/table-sorter/table-sorter';
import {LangService} from '../../../../../services/language/lang.service';
import {DialogService} from '../../../../../services/dialog/dialog.service';
import {TranslationErrorFormComponent} from '../translation-error-form/translation-error-form.component';

@Component({
  selector: 'app-translation-error-list',
  imports: [
    FormsModule,
    NgOptimizedImage,
    TableSorterHeaderDirective,
    TableSorterDirective
  ],
  templateUrl: './translation-error-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './translation-error-list.component.scss',
})
@IsGranted(['TRANSLATION_VIEW'])
@MetaTitle('Translation errors')
export class TranslationErrorListComponent implements OnInit {

  messages: TranslationMessage[] = [];
  tableSorter: TableSorter = new TableSorter('updatedAt', 'asc');

  constructor(
    private translationMessageService: TranslationMessageService,
    private dialogService: DialogService,
    protected loader: LoaderService,
    protected langService: LangService
  ) {
  }

  ngOnInit(): void {
    this.fetchAll();
  }

  fetchAll(): void {
    this.loader.startLoading();

    this.translationMessageService.findAll({
      withErrors: 1,
      groups: 'domain'
    }, null, this.tableSorter).subscribe((messages) => {
      this.messages = messages;

      this.loader.stopLoading();
    });
  }

  edit(message: TranslationMessage): void {
    this.dialogService.openDialog(TranslationErrorFormComponent, {
      data: message
    }).subscribe((response) => {
      if (response) {
        const i = this.messages.indexOf(message);
        this.messages.splice(i, 1);
      }
    });
  }
}
